import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.2.6_react-dom@19.2.1_react@19.2.1__react@19.2.1/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/src/lib/translate/i18n/client.ts");
;
import(/* webpackMode: "eager" */ "/app/src/lib/translate/i18n/i18n-context.tsx");
